import React from 'react';
import ChipInput from './ChipInput';

function App() {
  return (
    <div className="">
      <ChipInput />
    </div>
  );
}

export default App;
